import React from "react";
import Page500 from "src/views/pages/page500/Page500";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <Page500 />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
